import { render } from "./SajuInfoPopup.vue?vue&type=template&id=06436780&scoped=true"
import script from "./SajuInfoPopup.vue?vue&type=script&lang=js"
export * from "./SajuInfoPopup.vue?vue&type=script&lang=js"

import "./SajuInfoPopup.vue?vue&type=style&index=0&id=06436780&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06436780"]])

export default __exports__